import { Component, Input } from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { HeadingColor, HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { PictureObjectFit } from '@freelancer/ui/picture';
import { FontColor, TextSize } from '@freelancer/ui/text';

export enum ApiEnterpriseBackgroundPosition {
  LEFT = 'left',
  RIGHT = 'right',
}
@Component({
  selector: 'app-home-page-api-enterprise-section',
  template: `
    <fl-picture
      class="ApiEnterpriseSection-background"
      [attr.data-background-position]="apiEnterpriseBackgroundPosition"
      [alt]="header"
      [boundedHeight]="true"
      [boundedWidth]="true"
      [fullWidth]="true"
      [lazyLoad]="true"
      [objectFit]="PictureObjectFit.COVER"
      [src]="backgroundSrc"
    ></fl-picture>
    <fl-bit class="ApiEnterpriseSection-content">
      <fl-heading
        [color]="HeadingColor.LIGHT"
        [headingType]="HeadingType.H2"
        [size]="TextSize.SMALL"
        [sizeDesktop]="TextSize.MID"
        [sizeDesktopXLarge]="TextSize.XLARGE"
      >
        {{ header }}
      </fl-heading>
      <fl-heading
        [color]="HeadingColor.LIGHT"
        [headingType]="HeadingType.H3"
        [size]="TextSize.MID"
        [sizeDesktop]="TextSize.XLARGE"
        [sizeDesktopXLarge]="TextSize.XXXLARGE"
        [flMarginBottom]="Margin.XXSMALL"
        [flMarginBottomDesktop]="Margin.SMALL"
      >
        {{ subheader }}
      </fl-heading>
      <fl-text
        [color]="FontColor.LIGHT"
        [size]="TextSize.XXXSMALL"
        [sizeDesktop]="TextSize.SMALL"
        [sizeDesktopXLarge]="TextSize.MID"
        [flMarginBottom]="Margin.SMALL"
        [flMarginBottomDesktop]="Margin.LARGE"
      >
        {{ description }}
      </fl-text>
      <fl-button
        [flTrackingLabel]="trackingLabel"
        [color]="ButtonColor.PRIMARY_PINK"
        [link]="link"
        [size]="ButtonSize.MINI"
        [sizeDesktop]="ButtonSize.SMALL"
      >
        {{ cta }}
      </fl-button>
    </fl-bit>
  `,
  styleUrls: ['./api-enterprise-section.component.scss'],
})
export class HomePageApiEnterpriseSectionComponent {
  ApiEnterpriseBackgroundPosition = ApiEnterpriseBackgroundPosition;
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  FontColor = FontColor;
  HeadingColor = HeadingColor;
  HeadingType = HeadingType;
  Margin = Margin;
  PictureObjectFit = PictureObjectFit;
  TextSize = TextSize;

  @Input() apiEnterpriseBackgroundPosition =
    ApiEnterpriseBackgroundPosition.LEFT;
  @Input() backgroundSrc: string;
  @Input() cta: string;
  @Input() description: string;
  @Input() header: string;
  @Input() link: string;
  @Input() subheader: string;
  @Input() trackingLabel: string;
}
